/**
 * Die Schale: welcher Bildschirm gilt.
 *
 * **Eine Zustandsmaschine, keine Navigation.** Welcher Bildschirm gilt, folgt aus zwei Dingen —
 * welcher Token im Fragment steht (`routing/fragment.ts`) und, sobald eine Partie läuft, welchen
 * Status der Server meldet. Ein Router als Bibliothek wäre eine zweite Wahrheit über denselben
 * Zustand und müsste mit ihm synchron gehalten werden.
 *
 * **Der `switch` ist erschöpfend, und das prüft der Compiler** (`noFallthroughCasesInSwitch`
 * plus die diskriminierte Union). Eine neue Route ohne Fall wäre sonst ein leerer Bildschirm.
 */

import { AdminScreen } from './screens/AdminScreen.js';
import { BoardScreen } from './screens/BoardScreen.js';
import { HostScreen } from './screens/HostScreen.js';
import { JoinScreen } from './screens/JoinScreen.js';
import { StartScreen } from './screens/StartScreen.js';
import { useRoute } from './routing/useRoute.js';

export function App() {
  const route = useRoute();

  switch (route.kind) {
    case 'join':
      return <JoinScreen inviteToken={route.inviteToken} />;
    case 'host':
      return <HostScreen hostToken={route.hostToken} />;
    case 'admin':
      return <AdminScreen />;
    case 'board':
      return <BoardScreen />;
    case 'start':
      return <StartScreen />;
  }
}
